// extracted by mini-css-extract-plugin
export default {"container":"JImKZ","base":"YfmJp","metaText":"QK8nr","textContent":"bI8Rv","subheading":"O05rG","light":"dOEcN","imageContent":"tTC1I"};